import { useEffect, useState } from 'react';

/**
 * True while anything is being dragged over the page (an OS file, or a library
 * video from the sidebar). An embedded player's iframe swallows drag events, so
 * a drop target uses this to make its iframes click-through for the duration.
 */
export function useDragActive(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const start = () => setActive(true);
    const stop = () => setActive(false);
    const leave = (event: DragEvent) => {
      if (!event.relatedTarget) setActive(false);
    };
    window.addEventListener('dragenter', start);
    window.addEventListener('dragleave', leave);
    window.addEventListener('drop', stop, true);
    window.addEventListener('dragend', stop, true);
    return () => {
      window.removeEventListener('dragenter', start);
      window.removeEventListener('dragleave', leave);
      window.removeEventListener('drop', stop, true);
      window.removeEventListener('dragend', stop, true);
    };
  }, []);

  return active;
}
